import axios from 'axios';
import { adaptImpactFilters } from './adapters/filterAdapters';
import errorHandlerFactory from './errorHandler';
import { filterSummaries } from './adapters/csaImpactAdapter';

const errorHandler = errorHandlerFactory('An error occured when fetching CSA Impacts.');

export const csaImpacts = (filters = []) => {
    const filterObject = adaptImpactFilters(filters);

    // If the filter object isn't empty
    if (!(Object.entries(filterObject).length === 0)) {
        return axios.get('/csaimpact/csainfo', { params: filterObject })
            .then(r => r.data).catch(errorHandler);
    }
    throw Error('A CSA filter is required');
};

const csaImpactErrorHandler = errorHandlerFactory('An error occured when fetching CSA Impact Information.');

export const csaImpactInformation = (filters = []) => {
    const filterObject = adaptImpactFilters(filters);
    if (!(Object.entries(filterObject).length === 0)) {
        return axios.get('/csaimpact/getcsaimpactinfo', { params: filterObject })
            .then(r => filterSummaries(r.data)).catch(csaImpactErrorHandler);
    }
    throw Error('A CSA filter is required');
};
